function tooltipTrigger() {
    return {
        componentName: 'tooltipTrigger',
        baseStyle: {},
        variants: {
            nowrap: {
                whiteSpace: 'nowrap'
            }
        }
    };
}

export { tooltipTrigger as default };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidG9vbHRpcFRyaWdnZXIuanMiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy90aGVtZS9jb21wb25lbnRzL3Rvb2x0aXAvdG9vbHRpcFRyaWdnZXIudHMiXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgQ29tcG9uZW50U3R5bGUgfSBmcm9tICcuLi8uLi90eXBlcyc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIHRvb2x0aXBUcmlnZ2VyKCk6IENvbXBvbmVudFN0eWxlIHtcbiAgcmV0dXJuIHtcbiAgICBjb21wb25lbnROYW1lOiAndG9vbHRpcFRyaWdnZXInLFxuICAgIGJhc2VTdHlsZToge30sXG4gICAgdmFyaWFudHM6IHtcbiAgICAgIG5vd3JhcDoge1xuICAgICAgICB3aGl0ZVNwYWNlOiAnbm93cmFwJ1xuICAgICAgfVxuICAgIH1cbiAgfTtcbn1cbiJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFYyxTQUFVLGNBQWMsR0FBQTtJQUNwQyxPQUFPO0FBQ0wsUUFBQSxhQUFhLEVBQUUsZ0JBQWdCO0FBQy9CLFFBQUEsU0FBUyxFQUFFLEVBQUU7QUFDYixRQUFBLFFBQVEsRUFBRTtBQUNSLFlBQUEsTUFBTSxFQUFFO0FBQ04sZ0JBQUEsVUFBVSxFQUFFLFFBQVE7QUFDckIsYUFBQTtBQUNGLFNBQUE7S0FDRixDQUFDO0FBQ0o7Ozs7In0=
